export default defineNuxtPlugin(async () => {
  const rootStore = useRootStore()
  const route = await useRoute()
  const event = useRequestEvent()
  const req = event?.node.req

  // Storyblok url
  let storyblokLang
  if (req?.url?.includes('_storyblok')) {
    const parsedUrl = new URLSearchParams(req.url)
    storyblokLang = parsedUrl.get('_storyblok_lang') === 'default' ? 'nl' : parsedUrl.get('_storyblok_lang')

    if (storyblokLang) {
      rootStore.setLanguage(storyblokLang)
    }
  }

  // Detect language
  if (route.meta && route.meta.forceLanguage) {
    rootStore.setLanguage(route.meta.forceLanguage)
  } else if (!storyblokLang) {
    rootStore.setLanguage('nl')
  }
})
